export class SecurityStatus {
  securityStatusId!: number;
  name!: string;
}
